import { ErrorCode, PortalApiError } from '@afterpaytouch/portal-api/types'
import { Route } from '../../config/router'
import { TrackingEvent } from '../../model/monitoring'
import { ErrorHandler, CheckoutErrorContext } from './types'
import { setCheckoutError } from '../../state'
import { CheckoutError, checkoutErrors, TerminalErrorCode } from '../../model'

const isCreditCheckOrAffordabilityDecline = (errorCode: ErrorCode): boolean =>
  errorCode === ErrorCode.AffordabilityDecline || errorCode === ErrorCode.CreditCheckFailure

const getExtraFromError = (errorCode: ErrorCode, error: PortalApiError): CheckoutError['extra'] => {
  if (isCreditCheckOrAffordabilityDecline(errorCode) && error.errorInfo?.isInitialLimit !== undefined) {
    return { isInitialLimit: error.errorInfo.isInitialLimit }
  }
  return undefined
}

export const createCheckoutStartDefaultTerminalErrorHandler = (): ErrorHandler => ({
  canHandle: (): boolean => {
    return true // Always handles as fallback
  },

  handle: async (errorCode: ErrorCode, error: PortalApiError, context: CheckoutErrorContext): Promise<Route> => {
    context.logEvent(TrackingEvent.CHECKOUT_DECLINED, {
      isRecoverableTerminalError: false,
      errorCode,
    })

    context.dispatch(
      setCheckoutError({
        error: checkoutErrors[errorCode as ErrorCode] ?? TerminalErrorCode.Default,
        errorCode,
        extra: getExtraFromError(errorCode, error),
      })
    )

    return Route.TERMINAL_ERROR
  },
})
